'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-287/node_modules/@eliadmin/core/src/components/lightbox/lightbox-component.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-287/node_modules/@eliadmin/core/src/components/lightbox/lightbox-component.tsx").LightboxComponent>>;
const Deferred = lazy(() => import("@eliadmin/module-original/lightbox").then(m => ({ default: m.LightboxComponent })));
export function LightboxComponent(props: Props) { const opened = useRef(false); if (!props.isOpen && !opened.current) return null; opened.current = true; return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

